// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b31b97a2","812":"d5c15d14","906":"bd533fdf","922":"2d0b7d00"}[chunkId] + ".chunk.js";
};